export const useEnvPropsStore = defineStore('envPropsStore', {
  state: () => ({
    envProps: {},
  }),
});
